import { render, staticRenderFns } from "./HireCharge.vue?vue&type=template&id=70da9115"
import script from "./HireCharge.vue?vue&type=script&lang=js"
export * from "./HireCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports